/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { GenericIdDTO } from "./GenericIdDTO";
import { GenericIdDTOFromJSON, GenericIdDTOFromJSONTyped, GenericIdDTOToJSON } from "./GenericIdDTO";

/**
 *
 * @export
 * @interface PatchManyExternalDealFiltersSearchQueryDTO
 */
export interface PatchManyExternalDealFiltersSearchQueryDTO {
  /**
   *
   * @type {Array<GenericIdDTO>}
   * @memberof PatchManyExternalDealFiltersSearchQueryDTO
   */
  filterIds: Array<GenericIdDTO>;
  /**
   *
   * @type {string}
   * @memberof PatchManyExternalDealFiltersSearchQueryDTO
   */
  searchQuery: string;
}

/**
 * Check if a given object implements the PatchManyExternalDealFiltersSearchQueryDTO interface.
 */
export function instanceOfPatchManyExternalDealFiltersSearchQueryDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "filterIds" in value;
  isInstance = isInstance && "searchQuery" in value;

  return isInstance;
}

export function PatchManyExternalDealFiltersSearchQueryDTOFromJSON(
  json: any
): PatchManyExternalDealFiltersSearchQueryDTO {
  return PatchManyExternalDealFiltersSearchQueryDTOFromJSONTyped(json, false);
}

export function PatchManyExternalDealFiltersSearchQueryDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchManyExternalDealFiltersSearchQueryDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    filterIds: (json["filterIds"] as Array<any>).map(GenericIdDTOFromJSON),
    searchQuery: json["searchQuery"]
  };
}

export function PatchManyExternalDealFiltersSearchQueryDTOToJSON(
  value?: PatchManyExternalDealFiltersSearchQueryDTO | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    filterIds: (value.filterIds as Array<any>).map(GenericIdDTOToJSON),
    searchQuery: value.searchQuery
  };
}
